import { render, staticRenderFns } from "./product-row.vue?vue&type=template&id=21209514&scoped=true&"
import script from "./product-row.vue?vue&type=script&lang=js&"
export * from "./product-row.vue?vue&type=script&lang=js&"
import style0 from "./product-row.vue?vue&type=style&index=0&id=21209514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21209514",
  null
  
)

export default component.exports